"use client";

import { useEffect } from "react";
import { ApiErrorState } from "@/components/shared/api-error";
import { TrackPathEvent } from "@/features/analytics/track";

// Sunucu bileşeninde yakalanmayan hatalar (çoğunlukla rezervasyon API'sine ulaşılamaması).
// Hata ayrıntısı kullanıcıya gösterilmez; Next yalnızca digest iletir.
export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("Sayfa hatası", error.digest ?? "");
  }, [error]);
  return (
    <>
      <TrackPathEvent name="api_error" digest={error.digest} />
      <ApiErrorState reset={reset} />
    </>
  );
}
